import React, { type FunctionComponent } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminSettingsContainer from './AdminSettingsContainer';
import PortalRoutes from './components/PortalRoutes';
import Modal from './Modal';
import ModalContainer from './ModalContainer';
import { SETTINGS_HEADER_HEIGHT } from '../AdminSettings/SettingsHeader';

const StyledBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    grid-column: 2 / 3;
    grid-row: 2 / 3;

    padding: 1rem;

    height: calc(100vh - ${SETTINGS_HEADER_HEIGHT});
    overflow: scroll;

    /* allows for a comfortable way to reach content thats at the very bottom of a page */
    padding-bottom: 10rem;
`;

const PortalBody: FunctionComponent = () => {
    const { initialLoad } = useContainer(AdminSettingsContainer);
    const { modalContent, popModalContent, modalButtons } = useContainer(ModalContainer);

    const { t } = useTranslation('portal', { useSuspense: false });

    // TODO: I don't think design will like this solution 😳
    if (initialLoad) {
        return (
            <StyledBodyContainer>
                <Modal
                    content={modalContent}
                    onClose={() => {
                        popModalContent();
                    }}
                    buttons={modalButtons}
                />
                <Typography variant="body1">{t('body.loading')}</Typography>
            </StyledBodyContainer>
        );
    }

    return (
        <StyledBodyContainer>
            <Modal
                content={modalContent}
                onClose={() => {
                    popModalContent();
                }}
                buttons={modalButtons}
            />
            <PortalRoutes />
        </StyledBodyContainer>
    );
};

export default PortalBody;
